import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {CLASS_NAME_LOCALES_EMPTY, CLASS_NAME_LOCALES_HIDE} from '../constants';
import {useRuntimeEnvironment} from '@packages/systems/render';

const LocalesEmpty = Atom.createRender(
  ({context, attributes, classes, generateAttributes, data, renderChild}) => {
    const locales = context.get('locales') || [];
    const runtimeEnvironment = useRuntimeEnvironment();
    // We always want render LocalesEmpty in the Designer, regardless of the emptyState
    // so that the native node is in the DOM for UI tools.
    const inDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;
    const isEmpty = locales.length < 1;

    if (!isEmpty && !inDesigner) {
      return null;
    }

    const emptyClasses = isEmpty
      ? classes.push(CLASS_NAME_LOCALES_EMPTY)
      : classes.push(CLASS_NAME_LOCALES_EMPTY).push(CLASS_NAME_LOCALES_HIDE);

    const props = generateAttributes(attributes, emptyClasses);

    return (
      <div {...props}>
        {getChildren(data).map((child) => renderChild(child, context))}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Locales Empty',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Localization'), iconName('LocalesBlock')),
  },
  render: LocalesEmpty,
  showEmpty: false,
  constraints: {
    pinToParent: true,
    parent: [
      {
        is: 'LocalesWrapper',
        name: 'Element',
        rule: 'RequireOnly',
      },
    ],
  },
  fields: {
    children: TListOfElement,
  },
});

export default config;
